import { TFunction } from 'i18next'
import * as yup from 'yup'

export const createBussinessSchema = (t: TFunction<'business'>) =>
    yup.object().shape({
        businesses: yup.object().shape({
            business_type: yup.string().required(t('blank-errors')),
            business_place: yup.string().required(t('blank-errors')),
            business_content: yup
                .string()
                .required(t('blank-errors'))
                .min(100, t('min-characters', { count: 100 })),
            customer_id: yup.number().when('business_type', {
                is: 'meeting',
                then: (schema) =>
                    schema
                        .typeError(t('blank-errors'))
                        .positive(t('blank-errors'))
                        .required(t('blank-errors')),
                otherwise: (schema) => schema.notRequired(),
            }),
            meeting_purpose: yup.string().when('business_type', {
                is: 'meeting',
                then: (schema) => schema.required(t('blank-errors')),
                otherwise: (schema) => schema.notRequired(),
            }),
        }),
    })

export const cancleBussinessSchema = (t: TFunction<'business'>) =>
    yup.object().shape({
        businesses: yup.object().shape({
            business_reason_cancelled: yup.string().required(t('blank-errors')),
        }),
    })
